var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "60px",
    height: "50px",
    viewBox: "0 0 60 50",
    enableBackground: "new 0 0 60 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M23.066,40.166c14.077,0,21.779-11.672,21.779-21.78c0-0.328,0-0.656-0.015-0.985 c1.492-1.074,2.792-2.433,3.82-3.971c-1.373,0.612-2.851,1.016-4.402,1.21c1.582-0.941,2.791-2.449,3.374-4.24 c-1.478,0.881-3.12,1.508-4.867,1.852c-1.402-1.493-3.389-2.418-5.583-2.418c-4.225,0-7.658,3.433-7.658,7.657 c0,0.598,0.074,1.18,0.194,1.746c-6.359-0.312-12.002-3.373-15.779-8.001c-0.655,1.136-1.029,2.448-1.029,3.852 c0,2.658,1.358,5.001,3.403,6.375c-1.254-0.045-2.433-0.39-3.463-0.956v0.104c0,3.702,2.643,6.807,6.135,7.508 c-0.642,0.18-1.313,0.27-2.015,0.27c-0.493,0-0.971-0.045-1.433-0.135c0.97,3.045,3.806,5.254,7.149,5.314 c-2.627,2.061-5.926,3.283-9.509,3.283c-0.612,0-1.224-0.029-1.821-0.104C14.722,38.896,18.752,40.166,23.066,40.166"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterLogo);
export default __webpack_public_path__ + "static/media/twitter-logo.d43601f7.svg";
export { ForwardRef as ReactComponent };